export default __webpack_public_path__ + "static/media/f3.06e30c7d.jpg";